<template>
<div class="d-flex flex-wrap flex-lg-nowrap bg-white">
    <div class="position-relative container-search mr-1 mt-1 w-100">
        <b-form-input class="input-search w-100" 
          placeholder="Buscar"
          v-model="query" 
          trim
          autocomplete="off"
          @input="handleInput">
        </b-form-input>
        <b-icon class="icon-search" icon="search"></b-icon>
        <b-icon v-if="!loading_search" class="icon-x" icon="x" @click="deletedQuery"></b-icon>
        <b-spinner v-show="loading_search" variant="primary" class="loading-search" />
    </div>

    <b-dropdown
    v-if="view_actions"
    variant="flat-secondary"
    :text="$t('campaigns.actions')"
    class="avenir-medium mt-1 mr-1 dropdown-actions-inner-influencers"
    >
    <b-dropdown-item
        v-for="action in filteredActionsOptions"
        :key="action.value"
        @click="selectAction(action.value)"
        :disabled="action.disabled"
    >
        <component
          v-if="action.customIcon"
          :is="action.customIcon"
          :size="18"
          class="align-middle mr-05"
        />
        <feather-icon
        v-else-if="action.icon"
        :icon="action.icon"
        size="16"
        class="align-middle mr-05"
        />
        {{ action.text }}
    </b-dropdown-item>
    </b-dropdown>

    <component :is="vue_select" :options="$t('campaigns.filters.status')" label="text" v-model="filters.status" class="select-filters-type-inner-campaigns aditional-width mt-1" :append-to-body="true" v-if="view_filters_status">
      <template #option="{ text, value }">
        <div class="avenir-medium">
          {{  text }} ({{ number_status[value] }})
        </div>
      </template>
      <template #selected-option="{ text, value }">
        {{  text }} ({{ number_status[value] }})
      </template>
    </component>


    <component
      :is="vue_select"
      :options="$t('campaigns.filters.type')"
      label="text"
      v-model="filters.type"
      class="select-filters-type-inner-campaigns mt-1"
      :append-to-body="true"
    />
    <b-dropdown class="dropdown-networks-filter-inner form-control mt-1 mr-1" variant="link" toggle-class="" no-caret @show="caret_dropdown_nets = true" @hidden="caret_dropdown_nets = false">
    <template #button-content>
    {{ $t('network') }} ({{ filters.networks.length === 0 ? $t('campaigns.all') : filters.networks.length }})

    <feather-icon :icon="caret_dropdown_nets ? 'ChevronUpIcon' : 'ChevronDownIcon'" class="float-right"></feather-icon>
    </template>
    <b-dropdown-header class="p-0">
        <ul class="ul-networks-select">
        <li v-for="i in networks_avaibles" :key="i.value" :class="{'active-li': filters.networks.find(n => n.value === i.value)}" @click="toggleActionNet(i)">
            {{ i.text }}
            <feather-icon icon="CheckIcon" class="float-right" v-if="filters.networks.find(n => n.value === i.value)"></feather-icon>
        </li>
        </ul>
    </b-dropdown-header>
    </b-dropdown>
    <b-dropdown
      v-if="view_sort"
      class="dropdown-networks-filter-inner dropdown-sort-filter form-control mt-1 mr-1"
      variant="link"
      toggle-class=""
      no-caret
    >
      <template #button-content>
        {{ sortFieldLabel }}
        <span v-if="sortDirectionLabel" class="sort-hint">· {{ sortDirectionLabel }}</span>
      </template>
      <b-dropdown-header class="p-0">
        <ul class="ul-networks-select">
          <li
            v-for="opt in sort_field_options"
            :key="opt.value"
            :class="{ 'active-li': sort_field === opt.value }"
            @click="onSortItemClick(opt.value)"
          >
            {{ opt.label }}
            <feather-icon
              v-if="sort_field === opt.value"
              :icon="sort_direction === 'asc' ? 'ArrowUpIcon' : 'ArrowDownIcon'"
              size="13"
              class="float-right"
            />
          </li>
        </ul>
      </b-dropdown-header>
    </b-dropdown>
    <b-button v-if="view_btn_add_content" size="sm" @click="btn_action" class="blue-button mt-1" variant="blue-button">{{ $t('campaigns.addContentPublish') }}</b-button>
</div>
</template>

<script>
import { BSpinner, BFormInput, BIcon, BDropdown, BDropdownHeader, BDropdownItem, BButton, } from "bootstrap-vue";
export default {
  name: "FiltersDropdown",
  components: {
    BDropdown,
    BDropdownHeader,
    BDropdownItem,
    BSpinner,
    BFormInput,
    BIcon,
    BButton,
  },
  props: {
    networks_avaibles: {
      type: Array,
      default: () => []
    },
    actions_options: {
      type: Array,
      default: () => []
    },
    view_actions: {
      type: Boolean,
      default: false
    },
    view_filters_status: {
      type: Boolean,
      default: false
    },
    number_status: {
      type: Object,
      default: () => ({})
    },
    view_btn_add_content: {
      type: Boolean,
      default: false
    },
    btn_action: {
      type: Function,
    },
    view_sort: {
      type: Boolean,
      default: false
    },
    sort_field: {
      type: String,
      default: ''
    },
    sort_direction: {
      type: String,
      default: 'desc'
    },
    sort_field_options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      vue_select: null,
      query: '',
      caret_dropdown_nets: false,
      typing_timer: null,
      loading_search: false,
      filters: {
        type: this.$t('campaigns.filters.type')[0],
        status: this.$t('campaigns.filters.status')[0],
        networks: []
      }
    };
  },
  async mounted() {
    this.filters.networks = [...this.networks_avaibles];
    this.vue_select = (await import('vue-select')).default;
  },
  computed: {
    sortFieldLabel() {
      const opt = this.sort_field_options.find(o => o.value === this.sort_field);
      return opt ? opt.label : this.$t('campaigns.orderBy');
    },
    sortDirectionLabel() {
      const labels = this.$t('campaigns.orderByLabels');
      return labels?.[this.sort_field]?.[this.sort_direction] || '';
    },
    filteredActionsOptions() {
      return this.actions_options.filter(action => action.view_drop_item || !this.$store.getters['auth/isSuperUser'])
        .map(action => {
          return {
            ...action,
            text: this.$t(`campaigns.action_filters.${action.text}`),
            disabled: action.disabled || false
          };
        });
    }
  },
  methods: {
    selectAction(action) {
      this.$emit('action-selected', action);
    },
    toggleActionNet(net) {
      this.filters.networks = this.filters.networks.some(i => i.value === net.value) ? this.filters.networks.filter(i => i.value !== net.value) : [...this.filters.networks, net];
      this.getFilters();
    },
    deletedQuery() {
      this.query = '';
      this.getFilters(); 
    },
    handleInput() {
      clearTimeout(this.typing_timer)
      this.loading_search = true
      this.typing_timer = setTimeout(this.getFilters, 300)
    },
    onSortItemClick(field) {
      const new_direction = field === this.sort_field ? (this.sort_direction === 'asc' ? 'desc' : 'asc') : this.sort_direction;
      this.$emit('sort-changed', { field, direction: new_direction });
    },
    getFilters() {
      this.$emit('filters-changed', {
        query: this.query,
        type: this.filters.type?.value || '',
        networks: this.filters.networks.map(n => n.value),
        status: this.filters.status?.value || ''
      });
      this.loading_search = false;
    }
  },
  watch: {
    'filters.type'() {
      this.getFilters(); 
    },
    'filters.status'() {
      this.getFilters(); 
    },
    'filters.networks': {
      handler() {
        this.getFilters();
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">
.dropdown-sort-filter {
  min-width: 190px;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (min-width: 576px) and (max-width: 991.98px) {
    width: calc(50% - 0.5rem);
    min-width: unset;
  }
  .sort-hint {
    color: #6e6b7b;
    font-size: 0.8rem;
    margin-left: 0.2rem;
  }
}
.dropdown-networks-filter-inner {
  z-index: 100;
  .ul-networks-select {
    li {
      list-style: none;
      padding: 0.7em 1.2em;

      &:hover {
        background-color: #f5f5f5;
        cursor: pointer;
      }
      &.active-li {
        background-color: #e9ecef;
      }
    }
  }
}
.container-search .input-search {
  border-radius: 1.357rem;
  padding-left: 2.4em;
  padding-right: 3.5em;
  width: 100%;
  max-width: auto;
  height: 38px;
}
.container-search {
  @media (min-width: 576px) and (max-width: 991.98px) {
    width: 100% !important;
    flex: 0 0 100%;
    margin-bottom: 0.25rem;
  }
}

.icon-search {
  position: absolute;
  color: #6c757d;
  z-index: 8;
  top: 0.5em;
  left: 0.5em;
  font-size: 20px;
  cursor: pointer;
}
.icon-x {
  position: absolute;
  color: #6c757d;
  z-index: 8;
  top: 0.5em;
  right: 0.5em;
  font-size: 20px;
  cursor: pointer;
}
.loading-search {
  position: absolute;
  z-index: 8;
  top: 0.5em;
  right: 0.5em;
}
.dropdown-actions-inner-influencers {
  width: 250px;
  margin-right: 1em;
  z-index: 110;
  @media (max-width: 575.98px) {
    width: 100%;
    margin-right: 0;
  }
  @media (min-width: 576px) and (max-width: 991.98px) {
    width: calc(50% - 0.5rem);
    margin-right: 0;
  }
}
</style>
<style lang="scss">
.select-filters-type-inner-campaigns .vs__search::placeholder,
.select-filters-type-inner-campaigns .vs__dropdown-toggle
 {
  height: 46px ;
}
.select-filters-type-inner-campaigns .vs__clear {
  display: none;
}
.select-filters-type-inner-campaigns .vs__search {
  opacity: 0;
}
.vs__dropdown-menu {
  z-index: 100 !important;
}
.select-filters-type-inner-campaigns {
  width: auto;
  min-width: 250px;
  margin-right: 1em;

  @media (max-width: 575.98px) {
    width: 100%;
    margin-right: 0;
  }
  @media (min-width: 576px) and (max-width: 991.98px) {
    width: calc(50% - 0.5rem);
    min-width: unset;
    margin-right: 0;
  }
}
.dropdown-networks-filter-inner {
  width: auto;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (min-width: 576px) and (max-width: 991.98px) {
    width: calc(50% - 0.5rem);
  }
  height: 46px;
  .btn-link {
    color: #0f131a;
    font-family: 'avenir-heavy';
    padding: 11px 0px;
    width: 150px;
    text-align: left;
  }
  .dropdown-header, .dropdown-menu {
    padding: 0 !important;
    width: 100%;
    border-radius: 0.4em;
    overflow: hidden;
    font-family: 'avenir-medium';
  }
  .dropdown-menu {
    transform: translate3d(0px, 38px, 0px) !important;
  }
}
</style>